// Where each role lands after sign-in (call-map §2, flow map YES-275): the first match wins.
// The label names the page on the "Go to …" buttons of the access-denied and not-found screens.
const LANDINGS = [
    { permission: 'users.manage', path: '/admin/users', label: 'Users' },
    { permission: 'run.manage', path: '/runs', label: 'Runs' },
    { permission: 'coding.assigned', path: '/adjudicate', label: 'My queue' },
    { permission: 'lesson.own', path: '/dashboard', label: 'My lessons' },
];

const FALLBACK = { path: '/profile', label: 'Profile' };

export const landingFor = (can) => LANDINGS.find(({ permission }) => can(permission)) || FALLBACK;

// Navbar entries in display order (wf-shell-nav 1–4). An entry shows only if the role holds its
// permission; `match` lists the path prefixes that make it the active entry.
export const NAV_ENTRIES = [
    {
        label: 'My lessons',
        to: '/dashboard',
        match: ['/dashboard', '/lessons/'],
        // Researchers have lesson.own through the user permissions but no My lessons (decided 2026-10-22)
        show: ({ can }) => can('lesson.own') && !can('lesson.research'),
    },
    {
        label: 'Runs',
        to: '/runs',
        match: ['/runs'],
        show: ({ can }) => can('run.manage'),
    },
    {
        label: 'Lessons',
        to: '/lessons',
        match: ['/lessons', '/research/lessons'],
        show: ({ can }) => can('lesson.research'),
    },
    {
        label: 'Upload',
        to: '/upload',
        match: ['/upload'],
        show: ({ can }) => can('lesson.upload'),
    },
    {
        label: 'My queue',
        to: '/adjudicate',
        match: ['/adjudicate', '/annotate'],
        // Only annotators hold slots: researchers and admins have no coding.assigned (decision 2026-10-23)
        show: ({ can }) => can('coding.assigned'),
    },
];

// Admin ▾ lists Users and Activity (YES-316); Retention stays hidden until YES-274 is drawn
export const ADMIN_ENTRIES = [
    { label: 'Users', to: '/admin/users', show: ({ can }) => can('users.manage') },
    { label: 'Activity', to: '/admin/activity', show: ({ can }) => can('audit.read') },
];

export const ROLE_LABELS = {
    user: 'Teacher',
    annotator: 'Annotator',
    researcher: 'Researcher',
    admin: 'Admin',
};

export const isActive = (pathname, prefixes) =>
    prefixes.some((prefix) => pathname === prefix || pathname.startsWith(prefix.endsWith('/') ? prefix : `${prefix}/`));
